import devLogger from 'react-utils/devLogger';
import { isValidElement } from 'react';
export const getKeyFromStep = stepElement => {
  if (! /*#__PURE__*/isValidElement(stepElement)) return stepElement;
  const {
    key
  } = stepElement;
  if (process.env.NODE_ENV !== 'production' && typeof key !== 'string') {
    devLogger.warn({
      message: 'StepIndicator: stepName elements must have a `key`',
      key: 'StepIndicator-stepName-key'
    });
  }
  return key;
};